<template>
  <div id="app">
    <el-container style="height: 100vh;">
      <!-- 顶部导航栏 -->
      <el-header class="header">
        <!-- Logo 区域 -->
        <div class="logo">
          <img src="./assets/juzhe-logo.jpg" alt="Logo" />
        </div>

        <!-- 用户信息区域 -->
        <div class="user-info">
          <el-dropdown  append-to-body>
            <span class="el-dropdown-link">
              <el-avatar size="medium" src="http://gips2.baidu.com/it/u=195724436,3554684702&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960"></el-avatar>
              <!-- <span class="username">{{ username }}</span> -->
              <span class="username">{{ isVIP ? 'VIP用户' : '免费用户' }}</span>
              <el-icon><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu  class="el-dropdown-munu">
                <el-dropdown-item @click="goToSetting">系统设置</el-dropdown-item>
                <el-dropdown-item @click="goToBaidu">关于</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>


      <el-container  style="padding-top: 1px;">
        <!-- 侧边导航栏 -->
        <el-aside :width="isCollapse ? '64px' : '200px'" class="sidebar">
          <!-- 切换按钮 -->
          <!-- <div class="toggle-button">
            <el-button @click="toggleAside" type="text" icon class="collapse-button">
              <el-icon v-if="isCollapse"><ArrowRight /></el-icon>
              <el-icon v-else><ArrowLeft /></el-icon>
            </el-button>
            </div> -->
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo custom-menu"
            :collapse="isCollapse"
            router
          >
            
            <!-- <el-menu-item @click="toggleAside">
              <el-icon>
                <ArrowRight v-if="isCollapse" />
                <ArrowLeft v-else />
              </el-icon>
              <span class="menu-item-text" v-if="!isCollapse">
                {{ isCollapse ? 'Expand' : 'Collapse' }}
              </span>
            </el-menu-item> -->

            <el-menu-item index="/">
              <el-icon><HomeFilled /></el-icon>
              <span class="menu-item-text">首页</span>
            </el-menu-item>
            <el-menu-item index="/searchkeyword">
              <el-icon><Search /></el-icon>
              <span class="menu-item-text">搜索关键词</span>
            </el-menu-item>

            <el-menu-item index="/data-center/task-center">
              <el-icon><Operation /></el-icon>
              <span class="menu-item-text">任务中心</span>
            </el-menu-item>

            <el-sub-menu index="data-center">
              <template #title>
                <el-icon><DocumentCopy /></el-icon>
                <span class="menu-item-text">数据中心</span>
              </template>

              <el-menu-item index="/data-center/account">
                <!-- <el-icon><VideoCamera /></el-icon> -->
                <span class="menu-item-text">用户数据</span>
              </el-menu-item>

              <el-menu-item index="/data-center/work-data">
                <!-- <el-icon><VideoCamera /></el-icon> -->
                <span class="menu-item-text">作品数据</span>
              </el-menu-item>

              <el-menu-item index="/data-center/comment-data">
                <!-- <el-icon><ChatDotRound /></el-icon> -->
                <span class="menu-item-text">评论数据</span>
              </el-menu-item>

            </el-sub-menu>

            <el-menu-item index="/accountlist">
              <el-icon><User /></el-icon>
              <span class="menu-item-text">账号列表</span>
            </el-menu-item>
            <el-menu-item index="/setting">
              <el-icon><Setting /></el-icon>
              <span class="menu-item-text">系统设置</span>
            </el-menu-item>
          </el-menu>
          <!-- 侧边栏底部内容 -->
          <el-footer class="sidebar-footer">
            <el-button type="text" @click="toggleAside">
              <el-icon>
                <DArrowRight v-if="isCollapse" />
                <DArrowLeft v-else />
              </el-icon>
            </el-button>
          </el-footer>
        </el-aside>

        <!-- 主要内容区域 -->
        <el-main class="main-content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { 
  HomeFilled, 
  Search,
  Setting,
  User,
  DocumentCopy,
  DArrowLeft,
  DArrowRight,
  ArrowDown,
  Operation, } from '@element-plus/icons-vue';
  import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    HomeFilled,
    Search,
    Setting,
    User,
    DocumentCopy,
    DArrowLeft,
    DArrowRight,
    ArrowDown,
    Operation},
  data() {
    return {
      isCollapse: false, // 控制侧边栏是否缩回
      activeMenuItem: '1', // 默认选中的菜单项
      username: 'John Doe', // 用户名
      activationInfo: false,
    };
  },
  mounted() {
    this.$store.dispatch('fetchUserStatus');
    if (window.location.pathname === '/index.html') {
      this.$router.push('/'); // 替换为你希望的首页路径
    }
  },
  computed: {
    ...mapState(['isVIP']), // 绑定 Vuex 状态
    // ...mapState({
    //   isVIP: state => state.isVIP
    // })
  },
  methods: {
    // 跳转到系统设置页面
    goToSetting() {
      this.$router.push('/setting');
    },
    // 跳转到外部链接
    async goToBaidu() {
      // window.open('https://www.baidu.com', '_blank'); // 使用 window.open 打开新标签
      const abouturl = 'https://t32fq47ncf.feishu.cn/docx/Pb5mdyfJ2oeVDPxU8pscLO3rnBe';
      await window.pywebview.api.open_in_browser(abouturl);
    },
    toggleAside() { 
      this.isCollapse = !this.isCollapse; // 切换展开和收回状态
    },
    async loadActivationInfo() {
      try {
        const savedData = await window.pywebview.api.getActiveStatus();
        if (savedData) {
          this.activationInfo = savedData.activationStatus == '正常' || savedData.activationStatus == '试用';
          alert(this.activationInfo); 
        } 
      } catch (error) {
        console.error('加载失败:', error);
      }
    },
  },
};
</script>

<style>
/* 顶部导航栏样式 */
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-shadow: 0 4px 4px 0 #0000001a;
  background-color: rgb(255, 255, 255); 
  z-index: 999; /* 确保header在所有内容之上 */
}

/* Logo 样式 */
.logo img {
  height: 40px;
}

.el-dropdown-menu {
  z-index: 1000 !important;
}


/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  color: black;
}

.user-info .el-dropdown-link:focus {
  outline: none;
  align-items: center;
}

.user-info .username {
  margin-left: 20px;
  font-size: 14px;
  color: black;
  
}

/* 侧边栏及主内容区域样式 */
/* .el-aside.sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; 
  transition: width 0.3s;
} */
.el-aside.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  transition: width 0.3s;
}

.el-container {
  height: 100%;
  padding-top: 60px; /* 确保主内容不被header覆盖 */
}

.collapse-btn {
  position: absolute;
  bottom: 10px; /* 将按钮固定在侧边栏的底部 */
  width: 100%;
  text-align: center;
}

.el-main.main-content {
  flex: 1;
  margin-top: -30px;
  overflow: auto; /* 处理内容溢出 */

}

/* 侧边栏底部按钮样式 */
.sidebar-footer {
  text-align: center;
  padding-bottom: 10px;
}

.custom-menu >>> .el-menu-item.is-active {
  background-color: #f0f0f0; /* 选中时的淡淡背景色 */
}
.custom-menu >>> .el-menu-item.is-active {
  color: #42b983; /* 选中时的字体颜色 */
  font-weight: bold;
}
</style>